import React from 'react';

import { Flex, useTheme } from '@chakra-ui/react';

import { Button } from 'uiToolkitV1/Button';

export const RealignFooter = ({
  showRealignInThisTimelineAsRoot = false,
  handleRealignInThisTimelineAsRoot,
  hideRealignAsRoot = false,
  realignButtonText = 'Realign',
  onRealign,
  disableRealign,
  isMutating = false,
  isRemovingAlignment = false,
  onCancel,
  onRemoveAlignment,
}) => {
  const theme = useTheme();

  return (
    <Flex
      flex="auto 0 0"
      borderTopWidth="1px"
      h="72px"
      justifyContent="flex-end"
      alignItems="center"
      backgroundColor={theme.colors.neutral.F5F7F9}
      px={4}
      py={3}
    >
      <Button variant="tertiary" mr="auto" onClick={onCancel}>
        Cancel
      </Button>
      {hideRealignAsRoot ? null : (
        <Button variant="outlined" mr={4} onClick={onRemoveAlignment} isLoading={isRemovingAlignment}>
          Remove Alignment
        </Button>
      )}
      {showRealignInThisTimelineAsRoot ? (
        <Button variant="outlined" mr={4} onClick={handleRealignInThisTimelineAsRoot} isLoading={isRemovingAlignment}>
          Align at Strategic Level
        </Button>
      ) : null}

      <Button
        variant="filled"
        colorScheme="blue"
        onClick={onRealign}
        disabled={disableRealign}
        isLoading={!isRemovingAlignment && isMutating}
      >
        {realignButtonText}
      </Button>
    </Flex>
  );
};
